import { Controller } from 'react-hook-form'

function Select({ title, name, control, onChangeHandler, disabled = false }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const { value } = field

        const CheckOnChangeHandler = () => {
          if (!disabled) {
            const newValue = !value
            onChangeHandler(name, newValue)
          }
        }
        return (
          <label
            className={`flex items-center gap-3 ${
              disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
            }`}
            onClick={CheckOnChangeHandler}
          >
            <div
              className={`${
                value
                  ? 'border-transparent bg-gray-accent'
                  : 'border-gray-accent bg-white'
              } flex h-5 w-5 items-center justify-center rounded-full border-2 transition duration-300 ease-in-out lg-c:h-6 lg-c:w-6`}
            >
              <div
                className={`${
                  value ? 'bg-white' : 'bg-transparent'
                } h-2.5 w-2.5 rounded-full lg-c:h-3 lg-c:w-3`}
              />
            </div>
            <span className="text-nowrap">{title}</span>
          </label>
        )
      }}
    />
  )
}

export default Select
